/**
 * @react-pdf yalnız PNG ve JPG çizebiliyor; rozetler webp. Tarayıcıda
 * resmi yükleyip tuvalden PNG veri adresine çeviriyoruz. Yüklenemeyen
 * rozet atlanır, raporda o üye için eski görünüm kalır.
 */
export function loadImageAsPng(url, { size = 96, timeoutMs = 6000 } = {}) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    const timer = setTimeout(() => resolve(null), timeoutMs);
    img.onload = () => {
      clearTimeout(timer);
      try {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        if (!ctx) return resolve(null);
        ctx.drawImage(img, 0, 0, size, size);
        resolve(canvas.toDataURL("image/png"));
      } catch {
        resolve(null);
      }
    };
    img.onerror = () => {
      clearTimeout(timer);
      resolve(null);
    };
    img.src = url;
  });
}

/** Adres -> PNG veri adresi eşlemesi; başarısız olanlar yer almaz. */
export async function loadBadgeImages(urls, loader = loadImageAsPng) {
  const entries = await Promise.all((urls || []).map(async (url) => [url, await loader(url)]));
  return Object.fromEntries(entries.filter(([, data]) => Boolean(data)));
}
